<template>
    <div v-if="isMounted">
        <div class="card-body layout" :style="{'height': 800+'px'}">
            <div class="left">
                <div style="display: flex;flex-direction:row;justify-content:space-between">
                    <div>
                        <el-form :model="classForm" label-width="100px">
                            <el-form-item label="课程学科">
                                <el-input v-model="parentInfo.dialogData.subject_name" disabled style="width: 370px"></el-input>
                            </el-form-item>

                            <el-form-item label="任课老师">
                                <el-input v-model="parentInfo.dialogData.teacher_name" disabled style="width: 370px"></el-input>
                            </el-form-item>

                            <el-form-item label="开始时间">
                                <el-input v-model="classForm.start_time"  style="width: 370px"></el-input>
                            </el-form-item>

                            <el-form-item label="时长（分钟）">
                                <el-input v-model="classForm.time" style="width: 370px"></el-input>
                            </el-form-item>

                            <el-form-item label="备注">
                                <el-input v-model="classForm.note"  placeholder="请输入" style="width: 370px"></el-input>
                            </el-form-item>

                            <el-form-item label="教室">
                                <el-select v-model="classForm.classroom_id"
                                           style="width: 370px"
                                           filterable remote :remote-method="handleSearchClassroom"
                                           placeholder="请选择教室">
                                    <el-option
                                            v-for="item in classrooms"
                                            :key="item.id"
                                            :label="item.complete_name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="年级">
                                <el-radio-group v-model="classForm.grade_id" size="mini" @change="get_course">
                                    <el-radio-button border v-for="item in parentInfo.grades"
                                                     :label="item.id" :key="item.id">{{item.name}}</el-radio-button>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item label="班级类型">
                                <el-radio-group v-model="classForm.class_type_id" size="mini" @change="classTypeChange" :disabled="!classForm.name">
                                    <el-radio-button :label="1" v-if="parentInfo.dialogData.subject_id!=24">一对一</el-radio-button>
                                    <el-radio-button :label="4" v-if="parentInfo.dialogData.subject_id!=24">一对二</el-radio-button>
                                    <el-radio-button :label="2" v-if="parentInfo.dialogData.subject_id!=24">一对三</el-radio-button>
                                    <el-radio-button :label="6" v-if="parentInfo.dialogData.subject_id!=24">一对六</el-radio-button>
                                    <el-radio-button :label="3"  v-if="parentInfo.dialogData.subject_id!=24">小班</el-radio-button>
                                    <el-radio-button :label="5" v-if="parentInfo.dialogData.subject_id==24">晚托</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="班型">
                                <el-radio-group v-model="classForm.type" size="mini" @change="classTypeSecondChange">
                                    <el-radio-button :label="1">普通</el-radio-button>
                                    <el-radio-button :label="2" disabled>衔接</el-radio-button>
                                    <el-radio-button :label="3" disabled>Ti</el-radio-button>
                                    <el-radio-button :label="4">试听</el-radio-button>
                                    <el-radio-button :label="5">综评辅导</el-radio-button>
                                    <el-radio-button :label="6" v-if="parentInfo.filter.section_id==4">网络</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="冲刺课">
                                <el-checkbox v-model="classForm.sprintClass"></el-checkbox>
                            </el-form-item>

                            <el-form-item label="课程名称">
                                <el-input v-model="classForm.name" style="width: 370px"></el-input>
                            </el-form-item>

                            <el-form-item label="课次">
                                <el-input v-model="classForm.period" style="width: 370px" ></el-input>
                            </el-form-item>

                            <el-form-item label="单价"  v-if="parentInfo.filter.section_id!==4">
                                <el-input v-model="classForm.unit_period_price" style="width: 370px"></el-input>
                            </el-form-item>
                            <el-form-item label="单价(课次)" v-else>
                                <el-input v-model="classForm.unit_classHour" style="width: 370px"></el-input>
                            </el-form-item>

                            <el-form-item>
                                <el-button size="small" @click="handleStore" :loading="parentInfo.create_special_button_loading">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="display: flex;flex-direction: column;justify-content: center;writing-mode:lr-tb;text-align: center;width: 30px;" @click="advancedSetting">
                        高<br>级
                    </div>
                </div>

            </div>
            <div class="right" style="margin-left:500px">
                <div v-if="advanced">
                    <el-form :model="classForm" label-width="70px">
                        <el-form-item label="开始日期" style="height: 30px">
                            <el-date-picker
                                    v-model="classForm.start_date"
                                    type="date"
                                    :clearable="false"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateSpecialClass",
        data() {
            return {
                button_loading:false,
                advanced:true,
                title: '创建课程',
                loading: true,
                isMounted:false,
                classForm:{
                    name:'',
                    classroom_id:'',
                    note:'',
                    subject_id:0,
                    teacher_id:0,
                    time_sortBy:0,
                    semester_id:0,
                    class_type_id:'',
                    grade_id:0,
                    period:1,
                    unit_period_price:0,
                    start_date:'',
                    nightClass:false,
                    type:4,
                    classHeight:'',
                    start_time:'',
                    time:'',
                    unit_classHour:1,
                    sprintClass:false,
                },
                coursePeriods:{},
                classrooms:'',

            }
        },
        mounted() {
            this.parentInfo =this.$parent.$parent;
            this.$wApi.addListen(this.parentInfo.path,this.handleData);
            this.classForm.start_date=this.parentInfo.dialogData.date;
            this.classForm.subject_id=this.parentInfo.dialogData.subject_id;
            this.classForm.teacher_id=this.parentInfo.dialogData.teacher_id;
            this.classForm.classHeight=this.parentInfo.dialogData.classHeight;
            this.classForm.start_time=this.parentInfo.dialogData.start_time;
            this.classForm.time=this.parentInfo.dialogData.time;
            this.classForm.semester_id=this.parentInfo.filter.semester_id;
            if(this.parentInfo.filter.section_id==4){
                this.classForm.sprintClass=true;
            }
            this.handleIndexClassroom();
            this.isMounted=true;
        },
        computed: {
            classTypes() {
                return JSON.parse(localStorage.config).classTypes;
            }
        },
        methods:{
            advancedSetting() {
                this.advanced=true;
            },
            handleData(event,data){
                switch (event) {
                    case 'get_course':
                        this.coursePeriods=data.coursePeriods;
                        if(this.classForm.subject_id==24){
                            this.classForm.name='晚托';
                        }else{

                            this.classForm.name=this.parentInfo.grades[this.classForm.grade_id].name+this.parentInfo.dialogData.subject_name
                        }
                        break;
                    case 'search_classroom_for_specialClass':
                        this.classrooms = data.classrooms;
                        break;
                    case 'classroom_show_for_specialClass':
                        this.classrooms=data.classrooms
                        break;

                }
            },
            handleStore() {
                this.parentInfo.create_special_button_loading = true;
                this.$wApi.send(this.parentInfo.path, 'store_specialClass', {'classForm': this.classForm,'section_id': this.parentInfo.filter.section_id});
            },
            get_course() {
                this.classForm.class_type_id='';
                this.classForm.period=1;
                this.classForm.unit_period_price=0;
                this.$wApi.send(this.parentInfo.path, 'get_course', {
                    'grade_id': this.classForm.grade_id,
                    'subject_id': this.classForm.subject_id,
                    'class_type_id': this.classForm.class_type_id,
                    'semester_id':  this.classForm.semester_id
                });
            },
            handleIndexClassroom() {
                this.$wApi.send(this.parentInfo.path,'classroom_show_for_specialClass',{
                    'start_date':this.classForm.start_date,
                    'start_time':this.classForm.start_time,
                    'time':this.classForm.time,
                    'section_id':this.parentInfo.filter.section_id
                });
            },
            handleSearchClassroom(query) {
                this.$wApi.send(this.parentInfo.path,'search_classroom_for_specialClass',{
                    'start_date':this.classForm.start_date,
                    'start_time':this.classForm.start_time,
                    'time':this.classForm.time,
                    'classroom_name':query,
                    'section_id':this.parentInfo.filter.section_id
                });
            },
            classTypeChange(val){
                this.coursePeriods.forEach((item)=>{
                    if(item.class_type_id == val)
                    {
                        this.classForm.unit_period_price=0
                        this.classForm.name=this.parentInfo.grades[this.classForm.grade_id].name+
                            this.parentInfo.dialogData.subject_name+
                            this.parentInfo.class_types[this.classForm.class_type_id].name;
                    }
                })
            },
            classTypeSecondChange(val){
                if(val==4){
                    this.classForm.period=1;
                    this.classForm.unit_period_price=0;
                }else if(val==5){
                    this.classForm.period=2;
                    this.classForm.unit_period_price=644;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .layout{
        .left {
            float: left;
            width: 540px;
        }

        .right {
            margin-left:570px
        }
    }
    .modal{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index:3000;
    }
    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }
    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }
    .modal-header{
        font-size: 12px;
    }
    .modal-title {
        margin: 0;
        line-height: 1.5;
    }
    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }
    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0,0,0,.18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }
    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }
    .modal .close:hover {
        opacity: .5;
    }
</style>